// extracted by mini-css-extract-plugin
module.exports = {"vanlife-M":"M_vanlife-M__ztzG5"};